























































import { Component, Vue } from 'vue-property-decorator'
import { mapGetters, mapMutations, mapActions } from 'vuex'

import BuilderDefaultContainer from '@/components/builder/BuilderDefaultContainer.vue'
import BuilderSidebar from '@/components/builder/BuilderSidebar.vue'
import BuilderButton from '@/components/builder/BuilderButton.vue'
import BuilderTooltip from '@/components/builder/BuilderTooltip.vue'
import BuilderNavigationStep from '@/components/builder/BuilderNavigationStep.vue'
import AppExampleDialogMessages from './components/AppExampleDialogMessages.vue'
import StepsNavigation from './components/StepsNavigation.vue'

@Component({
  components: {
    BuilderDefaultContainer,
    BuilderTooltip,
    BuilderButton,
    BuilderSidebar,

    BuilderNavigationStep,
    StepsNavigation,
    AppExampleDialogMessages,
  },
  computed: {
    ...mapGetters('buildergpt', ['getCurrentStep', 'getApp']),
  },
  methods: {
    ...mapMutations('buildergpt', ['changeStep', 'setData', 'setTariffs']),
    ...mapActions('buildergpt', ['saveData']),
  },
})
export default class BuilderGptStep2 extends Vue {
  setData!: any
  setTariffs!: any
  getApp!: any
  loaded = true
  viewMode = false
  processing = false

  validationErrors = false
  stepData = {
    name: '',
    currency: '',
  }

  setCurrentTariffs() {
    this.setTariffs({
      ...this.getApp,
      tariffs: [],
    })
  }
  getCurrentStep!: number
  saveData!: any

  get isNextStepDisabled(): boolean {
    return !this.stepData.name
  }

  validateAppName(name: string): boolean {
    if (!/^[a-z0-9A-Z\-\\.\\_]*$/.test(name)) {
      this.$toasted.error(String(this.$t('errors.pageName.symbols')))
      return false
    }
    if (name.length > 30 || name.length < 3) {
      this.$toasted.error(String(this.$t('errors.pageName.count')))
      return false
    }
    return true
  }

  async confirmStep(): Promise<void> {
    if (!this.validateAppName(this.stepData.name)) {
      this.validationErrors = true
      return
    }
    this.validationErrors = false

    await this.saveData(this.stepData)
    this.$router.push({ path: `/gpt/step/${this.getCurrentStep}` })
  }
  mounted() {
    this.stepData.name = this.getApp.name
    if (this.getApp.currency) {
      this.stepData.currency = this.getApp.currency
    } else {
      this.stepData.currency = this.$i18n.locale === 'ru' ? 'RUB' : 'USD'
    }
  }
}
